import { useEffect } from 'react';
import useStore from '../../../store';
import { setupCanvasPointerListeners } from '../utils/canvasPointerHandler';

// Принимает refs на оба канваса
const usePuzzlePointer = (boardCanvasRef, trayCanvasRef) => {

  useStore(s => s.puzzleRender); // Следим за puzzleRender для обновления динамических элементов типа DraggingPiece


  const { ref } = useStore.getState(); // Доступ к ref для методов пазла
  const { puzzle } = ref;
  const { state } = puzzle;

  useEffect(() => {

    if (!state.isInitialized) return;

    const boardCanvas = boardCanvasRef.current;
    const store = useStore.getState(); // Передаем актуальный store в setup

    let boardCleanup = () => {};

    // Устанавливаем слушатели для канваса доски
    if (boardCanvas) {
      console.log("Setting up pointer listeners for BOARD canvas");
      boardCleanup = setupCanvasPointerListeners(boardCanvas, store, 'board');
    }

    // Очистка слушателей при размонтировании или изменении refs
    return () => {
      console.log("Cleaning up pointer listeners");
      boardCleanup();
    };
    // Зависимости: refs канвасов и методы пазла (если они меняются)
  }, [state.isInitialized]);
};

export default usePuzzlePointer;